/* cx-rank.js - shared scoring v3 for One Frame (/pages/one) and My Shelf (/pages/my-shelf).
   One Frame v3 / My Shelf v4, built 2026-07-15.
   score(item) = verified-fit bonus (dominant, 1..2: face width from localStorage
   cxvto_face_mm vs item.mm, ideal +2mm, comfort range -5mm..+9mm) PLUS device-local
   affinity boosts. Unknown and out-of-range widths remain eligible with no fit bonus:
     +0.30 handle in cx_carted
     +0.20 title matches a cx_tried model
     +0.15 title/tags match a cx_asked query token, or a model in a cx_asked results list
     +0.12 handle in cx_viewed
     +0.10 tagged New (as v1)
   Deterministic, stable sort (score desc, handle asc tie-break). Explanations are assembled
   ONLY from parts that actually contributed - nothing is invented. All signals live in
   localStorage on this device; nothing is sent anywhere. ASCII only. */
(function(){
  var KEYS = ['cx_viewed', 'cx_carted', 'cx_tried', 'cx_asked'];
  var STOP = {'the':1,'and':1,'for':1,'with':1,'that':1,'this':1,'something':1,'like':1,
    'look':1,'looking':1,'make':1,'made':1,'want':1,'need':1,'give':1,'show':1,'find':1,
    'frames':1,'frame':1,'sunglasses':1,'glasses':1,'pair':1,'some':1,'one':1,'ones':1,
    'you':1,'your':1,'get':1,'can':1,'has':1,'have':1,'are':1,'was':1,'but':1,'not':1};

  function readList(key){
    try{
      var a = JSON.parse(localStorage.getItem(key) || '[]');
      return Object.prototype.toString.call(a) === '[object Array]' ? a : [];
    }catch(e){ return []; }
  }
  function signals(){
    return {
      viewed: readList('cx_viewed'),
      carted: readList('cx_carted'),
      tried: readList('cx_tried'),
      asked: readList('cx_asked')
    };
  }
  function norm(s){
    return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '') + ' ';
  }
  function hasPhrase(hayNorm, needle){
    var n = norm(needle);
    if(n.replace(/\s/g, '').length < 2) return false;
    return hayNorm.indexOf(n) >= 0;
  }
  function tokens(q){
    var raw = norm(q).split(' '), out = [], i;
    for(i = 0; i < raw.length; i++){
      if(raw[i] && raw[i].length > 2 && !STOP[raw[i]]) out.push(raw[i]);
    }
    return out;
  }
  function fitComponent(mm, face){
    if(typeof mm !== 'number' || !isFinite(mm)) return null;
    var d = mm - face;
    if(d < -5 || d > 9) return 0;
    return 1 - Math.abs(d - 2) / 7;
  }
  function evaluate(item, face, sig){
    var mm = typeof item.mm === 'number' && isFinite(item.mm) ? item.mm : null;
    var delta = mm === null ? null : mm - face;
    var fit = fitComponent(mm, face);
    var fitPass = delta !== null && delta >= -5 && delta <= 9;
    var hay = norm((item.title || '') + ' ' + (item.tags || []).join(' '));
    var parts = [], score = fitPass ? 1 + fit : 0, i, j, x, hit;

    hit = null;
    for(i = 0; i < sig.carted.length; i++){ x = sig.carted[i]; if(x && x.h === item.handle){ hit = x; break; } }
    if(hit){ score += 0.30; parts.push({k: 'carted', t: hit.t, w: 0.30}); }

    hit = null;
    for(i = 0; i < sig.tried.length; i++){ x = sig.tried[i]; if(x && x.m && hasPhrase(hay, x.m)){ hit = x; break; } }
    if(hit){ score += 0.20; parts.push({k: 'tried', m: hit.m, t: hit.t, w: 0.20}); }

    hit = null;
    for(i = 0; i < sig.asked.length && !hit; i++){
      x = sig.asked[i];
      if(!x) continue;
      var models = x.models || [];
      for(j = 0; j < models.length; j++){ if(hasPhrase(hay, models[j])){ hit = x; break; } }
      if(!hit){
        var tk = tokens(x.q);
        for(j = 0; j < tk.length; j++){ if(hay.indexOf(' ' + tk[j] + ' ') >= 0){ hit = x; break; } }
      }
    }
    if(hit){ score += 0.15; parts.push({k: 'asked', q: hit.q, t: hit.t, w: 0.15}); }

    hit = null;
    for(i = 0; i < sig.viewed.length; i++){ x = sig.viewed[i]; if(x && x.h === item.handle){ hit = x; break; } }
    if(hit){ score += 0.12; parts.push({k: 'viewed', t: hit.t, w: 0.12}); }

    if(item['new']){ score += 0.10; parts.push({k: 'new', w: 0.10}); }

    return {item: item, score: score, fit: fit, delta: delta, fitKnown: mm !== null, fitPass: fitPass, parts: parts};
  }
  function rank(items, face){
    var sig = signals(), out = [], i, e;
    for(i = 0; i < items.length; i++){
      e = evaluate(items[i], face, sig);
      if(e) out.push(e);
    }
    out.sort(function(a, b){
      if(b.score !== a.score) return b.score - a.score;
      return a.item.handle < b.item.handle ? -1 : (a.item.handle > b.item.handle ? 1 : 0);
    });
    return out;
  }
  function when(t){
    if(!t) return '';
    var d = new Date(t), now = new Date();
    if(now - d < 0) return '';
    if(d.toDateString() === now.toDateString()) return 'today';
    var y = new Date(now.getTime() - 86400000);
    if(d.toDateString() === y.toDateString()) return 'yesterday';
    if(now - d < 561600000) return 'on ' + ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d.getDay()];
    return 'recently';
  }
  function whenSuffix(t){ var w = when(t); return w ? ' ' + w : ''; }
  function fitLine(e, face){
    var d = e.delta, pos;
    if(!e.fitKnown) return 'Its total frame width is not published, so fit did not affect this rank.';
    if(!e.fitPass){
      pos = d < -5 ? (-d) + 'mm narrower' : d + 'mm wider';
      return 'Its published ' + e.item.mm + 'mm width is ' + pos + ' than your ' + face + 'mm fit, outside your saved range.';
    }
    if(d === 2) pos = 'the ideal 2mm of room';
    else if(d >= 0) pos = d + 'mm wider, right in your range';
    else pos = (-d) + 'mm narrower, a snug fit inside your range';
    return 'Your ' + face + 'mm fit (this one is ' + e.item.mm + 'mm, ' + pos + ').';
  }
  function whyLines(e, face){
    var lines = [fitLine(e, face)], i, p;
    for(i = 0; i < e.parts.length; i++){
      p = e.parts[i];
      if(p.k === 'carted') lines.push('It has been in your cart' + whenSuffix(p.t) + '.');
      else if(p.k === 'tried') lines.push('You tried the ' + p.m + whenSuffix(p.t) + '.');
      else if(p.k === 'viewed') lines.push('You have looked at it before.');
      else if(p.k === 'asked') lines.push('You asked for "' + p.q + '"' + whenSuffix(p.t) + '.');
    }
    return lines;
  }
  function chip(e){
    var best = null, i, p;
    for(i = 0; i < e.parts.length; i++){
      p = e.parts[i];
      if(!best || (p.w || 0) > (best.w || 0)) best = p;
    }
    if(best){
      if(best.k === 'carted') return 'was in your cart';
      if(best.k === 'tried') return 'you tried this';
      if(best.k === 'asked') return 'you searched for this';
      if(best.k === 'viewed') return 'you viewed this';
      if(best.k === 'new') return 'new arrival';
    }
    if(!e.fitKnown) return 'fit unconfirmed';
    if(!e.fitPass) return 'outside fit range';
    var d = e.delta;
    return 'fits ' + (d >= 0 ? '+' : '') + d + 'mm';
  }
  function reset(){
    for(var i = 0; i < KEYS.length; i++){
      try{ localStorage.removeItem(KEYS[i]); }catch(e){}
    }
  }
  window.CXRank = {rank: rank, whyLines: whyLines, chip: chip, reset: reset, signals: signals, when: when};
})();
